import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** 边界名，用于错误提示文案 */
  name: string;
}

interface State {
  error: Error | null;
}

/** 每视图独立错误边界（docs/UI设计.md §8）：一个视图崩了不应带倒整页。 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(`[${this.props.name}] 渲染失败`, error, info.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div className="grid flex-1 place-items-center p-6">
        <div
          className="max-w-[420px] rounded-[10px] border p-5 text-center"
          style={{ background: 'var(--bg-surface)' }}
          role="alert"
        >
          <div className="mb-1.5 text-[14px] font-semibold">{this.props.name}加载失败</div>
          <p className="mb-4 text-[12px]" style={{ color: 'var(--text-2)' }}>
            {error.message}
          </p>
          <button
            type="button"
            onClick={() => this.setState({ error: null })}
            className="rounded-[6px] px-3 py-1.5 text-[12px] font-medium text-white"
            style={{ background: 'var(--accent)' }}
          >
            重试
          </button>
        </div>
      </div>
    );
  }
}